import React from 'react'
import { Container, Loader } from './style'

export default function CircularProgressDisabled() {
    return (
        <Container>
            <Loader></Loader>
        </Container>
    )
}